import "./RiskChangeControls.scss";

export const RiskChangeControls = "riskChangeControls";

const template = `
    <div class="changes-controls">
        <button class="btn btn-sm btn-danger revert-button" ng-click="ctrl.onRevert()">
            <i class="icon-cross"></i>
        </button>
        <button class="btn btn-sm btn-primary save-button" ng-click="ctrl.onSave()">
            <i class="icon-check"></i>
        </button>
    </div>
`;

export function riskChangeControls() {
    return {
        template,
        bindings: {
            onSave: "&",
            onRevert: "&"
        },
        controllerAs: "ctrl",
        controller: () => {}
    };
}
